import React from 'react';
import { CancellationFlowStep } from 'store/dashboard/types';
import CancellationConfirmation from 'components/Dashboard/Subscriptions/CancellationConfirmation/CancellationConfirmation';
import CancellationReasons from 'components/Dashboard/Subscriptions/CancellationReasons/CancellationReasons';
import CancellationResult from 'components/Dashboard/Subscriptions/CancellationResult/CancellationResult';
import { useSelector } from 'react-redux';
import getCancellationFlowStep from 'store/dashboard/selector/getCancellationFlowStep';

const CancellationFlow = () => {
  const step = useSelector(getCancellationFlowStep);

  if (step === CancellationFlowStep.initial) {
    return null;
  }

  return (
    <div>
      {step === CancellationFlowStep.confirmation && <CancellationConfirmation />}
      {step === CancellationFlowStep.reasons && <CancellationReasons />}
      {step === CancellationFlowStep.cancelled && <CancellationResult />}
    </div>
  );
};

export default CancellationFlow;
